<!-- Campaign Detail Page -->
<ng-template #campaignHeaderControls>
  @if (workflow.state(); as state) {
    <app-stage-chip [stage]="state.stage" [label]="state.label" />
  }
  <button hlmBtn type="button" variant="ghost" size="icon" class="!size-8 rounded-lg text-muted-foreground hover:text-foreground" aria-label="Weitere Aktionen" [brnMenuTriggerFor]="campaignMenu">
    <ng-icon name="lucideEllipsis" class="size-4" />
  </button>
</ng-template>

<ng-template #campaignMenu>
  <hlm-menu class="w-52">
    @if (currentOrgStore.can('campaign', 'update')) {
      <button hlmMenuItem (click)="notificationsOpen.set(true)">Benachrichtigungen</button>
    }
    @if (currentOrgStore.can('campaign', 'export')) {
      <button hlmMenuItem (click)="exportCampaign('excel')">Exportieren: Excel</button>
      <button hlmMenuItem (click)="exportCampaign('csv')">Exportieren: CSV</button>
    }
    @if (currentOrgStore.can('campaign', 'update')) {
      <hlm-menu-separator />
      <button hlmMenuItem (click)="archive()">Archivieren</button>
    }
  </hlm-menu>
</ng-template>

@if (currentOrgStore.can('campaign', 'read') && !currentOrgStore.can('campaign', 'update')) {
  <div [class]="fullBleed() ? 'border-b border-border px-4 py-2' : 'mb-6'">
    <app-inline-notice message="Nur Lesezugriff: Die Kampagne kann angesehen, aber nicht bearbeitet, gestartet oder exportiert werden." />
  </div>
}
@if (isLoading() && !campaign()) {
  <app-state-panel state="loading" title="Kampagne wird geladen" />
}
@if (hasError()) {
  <app-inline-notice tone="error" [message]="errorMessage() || 'Ein unbekannter Fehler ist aufgetreten'" />
}

@if (campaign()) {
  <div [class]="fullBleed() ? 'flex min-h-0 flex-1 flex-col' : ''">
    @switch (activeTab()) {
      @case ('overview') { <app-campaign-overview-tab /> }
      @case ('analyses') { <app-campaign-analyses-tab /> }
      @case ('executions') { <app-campaign-executions-tab /> }
      @case ('review') { <app-campaign-result-review-tab /> }
      @case ('plannings') { <app-campaign-planning-results-tab /> }
    }
  </div>
}

@if (workflow.runDetailId()) {
  <app-campaign-run-detail />
}

@if (workflow.runPanel(); as options) {
  <app-campaign-run-panel [options]="options" />
}

@if (notificationsOpen() && currentOrgStore.organizationId(); as orgId) {
  <app-side-panel heading="Benachrichtigungen" subtitle="Wer erfährt, wenn eine Berechnung fertig ist" (closed)="notificationsOpen.set(false)">
    <div class="p-5"><app-notification-routing [organizationId]="orgId" scope="campaign" [sourceId]="campaign()!.id" /></div>
  </app-side-panel>
}

<hlm-dialog [state]="editOpen() ? 'open' : 'closed'" (closed)="editOpen.set(false)">
  <hlm-dialog-content *brnDialogContent="let ctx" class="sm:max-w-lg">
    <hlm-dialog-header>
      <h2 hlmDialogTitle>Kampagne bearbeiten</h2>
      <p hlmDialogDescription>Name und Beschreibung der Kampagne aktualisieren.</p>
    </hlm-dialog-header>
    <form class="space-y-4" (ngSubmit)="saveDetails()">
      <label class="block space-y-1.5 text-sm font-normal">Name
        <input hlmInput name="title" required maxlength="255" [ngModel]="editTitle()" (ngModelChange)="editTitle.set($event)" [disabled]="isSaving()" />
      </label>
      <label class="block space-y-1.5 text-sm font-normal">Beschreibung
        <textarea hlmInput name="description" rows="3" [ngModel]="editDescription()" (ngModelChange)="editDescription.set($event)" [disabled]="isSaving()"></textarea>
      </label>
      @if (editError()) { <app-inline-notice tone="error" [message]="editError()" /> }
      <hlm-dialog-footer>
        <button hlmBtn type="button" variant="outline" [disabled]="isSaving()" (click)="editOpen.set(false)">Abbrechen</button>
        <button hlmBtn type="submit" [disabled]="isSaving() || !editTitle().trim()">{{ isSaving() ? 'Wird gespeichert…' : 'Speichern' }}</button>
      </hlm-dialog-footer>
    </form>
  </hlm-dialog-content>
</hlm-dialog>
